/*
* <license header>
*/

import React from 'react'
import { Button, Flex } from '@adobe/react-spectrum'
import Add from '@spectrum-icons/workflow/Add'
import Link from '@spectrum-icons/workflow/Link'

export const AssistantHeader = () => (
  <div
    className="AssistantHeader"
    style={{
      background: 'linear-gradient(90deg, #e85d4c 0%, #c77eb5 100%)',
      padding: '3rem 3rem 1rem 3rem',
      marginBottom: '2.5rem',
      borderRadius: '16px',
      minHeight: '12rem',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }}
  >
    <Flex alignItems="center" gap="size-150" UNSAFE_className="AssistantHeader-headingRow">
      <h1
        className="AssistantHeader-heading"
        style={{
          margin: 0,
          fontSize: '2rem',
          fontWeight: 700,
          color: 'white'
        }}
      >
        Chat with AppBuilder Factory Assistant
      </h1>
      <span
        style={{
          display: 'inline-block',
          padding: '0.2rem 0.5rem',
          borderRadius: '999px',
          backgroundColor: '#f4a261',
          color: 'white',
          fontSize: '0.75rem',
          fontWeight: 600
        }}
      >
        BETA
      </span>
    </Flex>
    <Flex gap="size-100" justifyContent="flex-end" UNSAFE_className="AssistantHeader-actions">
      <Button variant="secondary" UNSAFE_style={{ backgroundColor: 'rgba(255,255,255,0.2)', borderColor: 'rgba(255,255,255,0.5)', color: 'white' }}>
        <Link size="S" />
        <span style={{ marginLeft: '0.5rem' }}>#appbuilder-support</span>
      </Button>
      <Button variant="secondary" UNSAFE_style={{ backgroundColor: 'rgba(255,255,255,0.3)', borderColor: 'rgba(255,255,255,0.6)', color: 'white' }}>
        <Add size="S" />
        <span style={{ marginLeft: '0.5rem' }}>New conversation</span>
      </Button>
    </Flex>
  </div>
)
